var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"id":"app-closing"}},[_c('h3',{staticClass:"mt-50 text-center"},[_vm._v("\n    "+_vm._s(_vm.$t('button.dw_telecolection'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }